module.exports = __webpack_public_path__ + "img/faro-room.21eedf64.jpg";